<template>
  <div class="view">
    <Header title="Wareneingang" backLink="/" />
    <div class="content">
      <div class="content__inner">
        <Search placeholder="Produkt oder Platz scannen" @submit="query" ref="search" />
        <ProductTeaser v-if="product" :product="product" style="margin: 1rem 0;" />
        <div class="card" v-if="shelfSpace" style="margin: 1rem 0;">
          <router-link :to="{name: 'query', params: {shelfSpace}}" tag="div" class="card-body">
            <h4 class="card-title" style="margin: 0;">
              <ShelfBadge :label="`${ shelfSpace.shelfId }${ shelfSpace.spaceId }`" />
            </h4>
          </router-link>
        </div>
        <form @submit.prevent="stockItem">
          <div class="form-group" v-if="this.shelfSpace && this.product">
            <label for="amount">Menge</label>
            <input
              type="text"
              pattern="[0-9]*"
              required
              v-model="amount"
              id="amount"
              class="form-control"
            />
          </div>
          <div
            class="form-group"
            v-if="this.shelfSpace && this.product && this.product.type === 'food'"
          >
            <label for="expiryDate">Ablaufdatum</label>
            <input type="month" v-model="expiryDate" id="expiryDate" class="form-control" />
          </div>
          <button
            v-if="shelfSpace && product && amount"
            class="btn btn-primary"
            style="margin: 1rem 0; float: right;"
            type="submit"
          >Einlagern</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Search from '@/components/Search'
import ShelfBadge from '@/components/ShelfBadge'
import ProductTeaser from '@/components/ProductTeaser'
import { fb, db } from '@/shared/firebase'

export default {
  data() {
    return {
      input: '',
      readOnly: true,
      shelfSpace: null,
      product: null,
      amount: null,
      expiryDate: null
    }
  },
  components: { Header, Search, ShelfBadge, ProductTeaser },
  mounted: function() {
    const { product, shelfSpace } = this.$route.params
    this.product = product ? product : null
    this.shelfSpace = shelfSpace ? shelfSpace : null
    this.$refs.search.$el.focus()
  },
  methods: {
    query: function(result) {
      switch (result.type) {
        case 'product': {
          const product = _.find(this.$store.state.products, { id: result.productId })
          if (product) {
            product.productId = result.productId
          }
          this.product = product ? product : { notFound: true }
          break
        }
        case 'shelfSpace': {
          this.shelfSpace = {
            shelfId: result.shelfId,
            spaceId: result.spaceId
          }
          break
        }
      }
    },
    resetExpiryDate: function() {
      this.expiryDate = null
    },
    stockItem: function() {
      const { shelfSpace, product, amount } = this
      const item = {
        productId: product.id,
        amount: parseFloat(amount)
      }
      if (product.type === 'food' && this.expiryDate) {
        item.expiryDate = this.expiryDate
      }
      db.doc(`private/warehouse/shelves/${shelfSpace.shelfId}`)
        .update({
          [`spaces.${shelfSpace.spaceId}.items`]: fb.firestore.FieldValue.arrayUnion(item)
        })
        .then(() => {
          this.shelfSpace = null
          this.product = null
          this.amount = null
          this.expiryDate = null
          this.$refs.search.$el.focus()
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>
